var exports = {
  "Qs": "x4ddf2309--497c2c--content",
  "qr": "x4ddf2309--497c2c--footer",
  "nM": "x4ddf2309--497c2c--row",
  "IX": "x4ddf2309--497c2c--row-label",
};

module.exports = exports;
